import React, { Component } from 'react';
import { MessageBars } from '../Outils/MessageBars';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import '../../css/immocom.css';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { DataIndicateur } from '../../data/DataIndicateur.jsx';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    idLotCommercial

    onAffichePanelDetailIndicateurValidation
    onAnnuleFiche
    onPeutChargerLeComposant : bool (==false => on ne charge pas le composant ; ==true => on charge)

    titre
****************************************************************/

var objetState = {
    items: [],

    idOperation: 0,
    idReservation: 0,
    idLotCommercial: 0,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheDetailIndicateurValidation extends Component {
    _creationContent() {
        return (
            <Panel
                isOpen={this.props.onAffichePanelDetailIndicateurValidation}
                type={PanelType.extraLarge}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                headerText={this.props.titre}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className="ms-Grid" dir="ltr">
                    {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                    <div className="ms-Grid-row">
                        <MessageBars
                            errorMessage={this.state.errorMessage}
                            warningMessage={this.state.warningMessage}
                            onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                            onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                        />
                    </div>

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 ms-xxxl12">
                            <DetailsList
                                items={this.state.items}
                                columns={this.columns}
                                selectionMode={SelectionMode.none}
                            />
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        //#region chargement des columns
        let columnsTemp = [];
        columnsTemp.push({
            key: 'numero',
            name: 'N° lot',
            fieldName: 'numero',
            minWidth: 50,
            maxWidth: 50,
            isResizable: true,
            onRender: (item) => {
                let numLot = item.numero;

                return <span title={numLot}>{numLot}</span>;
            }
        });
        columnsTemp.push({
            key: 'lotType',
            name: 'Type',
            fieldName: 'lotType',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            onRender: (item) => {
                let nbPieces = item.lotType;

                return <span title={nbPieces}>{nbPieces}</span>;
            }
        });
        columnsTemp.push({
            key: 'etage',
            name: 'Etage',
            fieldName: 'etage',
            minWidth: 50,
            maxWidth: 50,
            isResizable: true
        });
        columnsTemp.push({
            key: 'batiment',
            name: 'Bât.',
            fieldName: 'batiment',
            minWidth: 50,
            maxWidth: 50,
            isResizable: true
        });
        columnsTemp.push({
            key: 'exposition',
            name: 'Expo.',
            fieldName: 'exposition',
            minWidth: 50,
            maxWidth: 50,
            isResizable: true
        });
        columnsTemp.push({
            key: 'surfaceHabitable',
            name: 'SHA',
            fieldName: 'surfaceHabitable',
            minWidth: 50,
            maxWidth: 50,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let surfaceHabitable = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.surfaceHabitable).toFixed(2), false, 2);

                return (item.surfaceHabitable !== null ? <span title={`${surfaceHabitable} m²`}>{`${surfaceHabitable} m²`}</span> : null);
            }
        });
        columnsTemp.push({
            key: 'quantite',
            name: 'Quantité',
            fieldName: 'quantite',
            minWidth: 50,
            maxWidth: 50,
            isResizable: true
        });
        columnsTemp.push({
            key: 'prixHTGrille',
            name: 'Prix grille HT',
            fieldName: 'prixHTGrille',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let prix = (this.props.idLotCommercial === null ? item.prixHTLotCommercial : item.prixHT);
                let prixHT = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(prix).toFixed(2), false, 2);

                return (item.prixHT !== null ? <span title={`${prixHT} €`}>{`${prixHT} €`}</span> : null);
            }
        });
        columnsTemp.push({
            key: 'tva',
            name: 'TVA',
            fieldName: 'tva',
            minWidth: 50,
            maxWidth: 50,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let tva = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.tauxTVA).toFixed(2), false, 2);

                return (this.props.idLotCommercial === null ? null : (item.tauxTVA !== null ? <span title={`${tva} %`}>{`${tva} %`}</span> : null));
            }
        });
        columnsTemp.push({
            key: 'remarques',
            name: 'Commentaire',
            fieldName: 'remarques',
            minWidth: 150,
            maxWidth: 400,
            isResizable: true,
            onRender: (item) => {
                let remarques = (this.props.idLotCommercial === null ? item.motifDesistement : item.remarques);

                return <span title={remarques}>{remarques}</span>;
            }
        });

        this.columns = columnsTemp;
        //#endregion

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [this.state.idOperation]);
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [this.state.idReservation]);

        if (idOperationRenseigneeEtDifferent && idReservationRenseigneeEtDifferent) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du détail'
            });

            var chargementFicheDetailIndicateurValidation = DataIndicateur._chargementFicheDetailIndicateurValidation(this.props.idOperation, this.props.idReservation, this.props.idLotCommercial);

            chargementFicheDetailIndicateurValidation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let retourData = responseFetch.reponseAPIobjet;

                        let stateTemp = {};
                        stateTemp.idReservation = this.props.idReservation;
                        stateTemp.idOperation = this.props.idOperation;
                        stateTemp.idLotCommercial = this.props.idLotCommercial;
                        stateTemp.items = (this.props.idLotCommercial === null ? [retourData] : retourData);

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <DefaultButton onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        //if (!this.state.enCoursDeTraitement && this.props.onPeutChargerLeComposant) {
        //    this._chargementDonnees();
        //}
    }

    render() {
        return (this._creationContent());
    }
}